import { DefaultApi } from './api';
import { AddressByZipCodeResponse } from './types';

export const getAddressByZipCode = (zipCode: string | number) =>
  DefaultApi.request<AddressByZipCodeResponse>(`/addresses/${zipCode}`, {
    method: 'GET',
  });
